<template>
<div>
    <template v-if="loading">
        <loading 
        class="user_view__reportList--loading">
        </loading>
    </template>
    <div v-else-if="error && !loading">
        <report-error></report-error>
    </div>
    <div v-else-if="data.length>0">
        <template v-if="type==='audio'">
            <audio-item 
                v-for="(aud, i) in data"
                :aud="aud"
                :color="color"
                :key="i" 
                class="user_view__reportList__audio">
            </audio-item>
        </template>
        <template v-else-if="type==='image'">
            <photo-list :data="data"></photo-list>
        </template>
        <template v-else-if="type==='alert'">
            <alert-list :data="data"></alert-list>
        </template>
    </div>
    <div v-else :style="type==='audio'?'margin: 33px 0% 0px 30%;':'margin: 33px 0% 0px 20%;'">
        <p><i>No se encuentran {{message}} disponibles</i></p>
    </div>
</div>
</template>
<script>
import ReportsError from './ReportsError'
import AudioItem from './AudioItem'
import PhotoList from './PhotosList'
import AlertLits from './AlertsList'
import Loading from './Loading'
export default {
   props:{
       data: Array,
       loading: {
           type: Boolean,
           default: true
       },
       error: Boolean,
       color: {
           type: String,
           default: '#FC3E3B' 
       },
       type:{
           type: String,
           default: 'audio'
       }
   },
   components: {
       'report-error': ReportsError,
       'audio-item': AudioItem,
       'loading': Loading,
       'photo-list': PhotoList,
       'alert-list': AlertLits
   },
    computed:{
       message () {
        if(this.type==='alert') return "alertas"
        if(this.type==='image') return "evidencias fotográficas"
        return "reportes"
      }
   }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ReportList.vue